import {GameCenterHeaderGoalAnimationSetModel} from "./game-center-header-goal-animation-set-model";
import {AnimationService} from "../../../../../infrastructure/models/animation/animation-service";
import {BaseAnimationSetModel} from "../../../../../infrastructure/models/animation/set-models/base-animation-set-model";
import {ANIMATIONS} from "../../../../../infrastructure/models/animation/game/animations-consts";
import {GameCenterHeaderPenaltyMissedAnimationSetModel} from "./game-center-header-penalty-missed-animation-set-model";
import {GameCenterHeaderYellowCardAnimationSetModel} from "./game-center-header-yellow-card-animation-set-model";
import {GameCenterHeaderRedCardAnimationSetModel} from "./game-center-header-red-card-animation-set-model";
import {GameCenterHeaderMatchStartedAnimationSetModel} from "./game-center-header-match-started-animation-set-model";
import {GameCenterHeaderMatchEndedAnimationSetModel} from "./game-center-header-match-ended-animation-set-model";
import {GameCenterHeaderMatchBreakTimeStartedAnimationSetModel} from "./game-center-header-match-break-time-started-animation-set-model";
import {GameCenterHeaderMatchBreakTimeEndedAnimationSetModel} from "./game-center-header-match-break-time-ended-animation-set-model";

export class GameCenterHeaderAnimationService extends AnimationService {
  static injectables = [...AnimationService.injectables];

  get animations(): Object<BaseAnimationSetModel> {
    const animations: Array<BaseAnimationSetModel> = {
      [ANIMATIONS.goal]: GameCenterHeaderGoalAnimationSetModel,
      [ANIMATIONS.redCard]: GameCenterHeaderRedCardAnimationSetModel,
      [ANIMATIONS.yellowCard]: GameCenterHeaderYellowCardAnimationSetModel,
      [ANIMATIONS.penaltyMiss]: GameCenterHeaderPenaltyMissedAnimationSetModel,
      [ANIMATIONS.matchStart]: GameCenterHeaderMatchStartedAnimationSetModel,
      [ANIMATIONS.matchEnd]: GameCenterHeaderMatchEndedAnimationSetModel,
      [ANIMATIONS.breakTimeStarted]: GameCenterHeaderMatchBreakTimeStartedAnimationSetModel,
      [ANIMATIONS.breakTimeEnded]: GameCenterHeaderMatchBreakTimeEndedAnimationSetModel,
    }

    return animations;
  }
}
